/* "Ver mais produtos" nas coleções (Loja Viego). Acrescenta a próxima página na mesma lista, sem recarregar.
   Se algo falhar, segue o link real para a próxima página. Ao voltar de um produto, recupera os produtos já abertos e a posição. */
(function () {
  if (!window.customElements || customElements.get('viego-ver-mais')) return;

  var inicial = null;
  var listaTodos = null;

  /* Só o que muda a lista entra na chave: scripts externos acrescentam parâmetros à URL (ex.: _su_rec) ao voltar de outra página. */
  function chave() {
    var q = [];
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k === 'page' || k === 'sort_by' || k.indexOf('filter.') === 0) q.push(k + '=' + v);
    });
    return 'vvm:' + location.pathname + '?' + q.sort().join('&');
  }
  function ler() { try { return JSON.parse(sessionStorage.getItem(chave())); } catch (e) { return null; } }
  function gravar(v) { try { sessionStorage.setItem(chave(), JSON.stringify(v)); } catch (e) {} }
  function apagar() { try { sessionStorage.removeItem(chave()); } catch (e) {} }

  function tipoNavegacao() {
    try { return performance.getEntriesByType('navigation')[0].type; } catch (e) { return 'navigate'; }
  }

  /* A compra e o clique no GA4 usam a lista de produtos do dataLayer: os novos entram nela, sem repetir os antigos. */
  function rastrear(itens, avisar) {
    var dl = window.dataLayer;
    if (!dl || !itens || !itens.length) return;
    var base = null, i;
    for (i = dl.length - 1; i >= 0 && !base; i--) {
      if (dl[i] && dl[i].ecommerce && dl[i].ecommerce.items && dl[i].productList) base = dl[i];
    }
    if (!listaTodos) listaTodos = base ? base.ecommerce.items.slice() : [];
    var nomeLista = base ? base.productList : undefined;
    itens = itens.filter(function (n) { return !listaTodos.some(function (a) { return a.productURL === n.productURL; }); });
    if (!itens.length) return;
    listaTodos = listaTodos.concat(itens);
    if (avisar) {
      dl.push({ ecommerce: null });
      dl.push({ productList: nomeLista, pageType: 'Collection', event: 'view_item_list', ecommerce: { items: itens } });
    }
    dl.push({ ecommerce: null });
    dl.push({ ecommerce: { items: listaTodos } });
  }

  function limparLink(a) {
    if (!a) return;
    var u = new URL(a.href, location.href);
    u.searchParams.delete('section_id');
    a.href = u.pathname + u.search;
  }

  class ViegoVerMais extends HTMLElement {
    connectedCallback() {
      this.ligar();
      if (inicial === null) inicial = Number(this.dataset.pagina) || 1;
      var self = this;
      addEventListener('pagehide', function () {
        if (!self.isConnected) return;
        var p = Number(self.dataset.pagina) || 1;
        if (p > inicial) gravar({ ate: p, y: window.scrollY }); else apagar();
      });
      this.recuperar();
    }

    ligar() {
      var self = this;
      this.botao = this.querySelector('[data-vvm-mais]');
      limparLink(this.botao);
      if (!this.botao) return;
      this.botao.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        var teclado = e.detail === 0;
        self.carregar(true).then(function (novos) {
          if (teclado && novos && novos[0]) { var l = novos[0].querySelector('a'); if (l) l.focus({ preventScroll: true }); }
        }).catch(function () { location.href = self.linkAtual; });
      });
      this.linkAtual = this.botao.href;
    }

    carregar(avisar) {
      var self = this;
      if (!this.botao || this.ocupado) return Promise.resolve([]);
      this.ocupado = true;
      this.classList.add('vvm--carregando');
      var u = new URL(this.botao.href, location.href);
      u.searchParams.set('section_id', this.dataset.secao);
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novos = [].slice.call(doc.querySelectorAll('.product-list__inner > *'));
        var outro = doc.querySelector('viego-ver-mais');
        var alvo = self.closest('.product-facet__main');
        alvo = alvo && alvo.querySelector('.product-list__inner');
        if (!novos.length || !alvo || !outro) throw new Error('resposta inesperada');
        var js = outro.querySelector('[data-vvm-itens]');
        var itens = [];
        if (js) { try { itens = JSON.parse(js.textContent); } catch (e) {} js.remove(); }
        var pedaco = document.createDocumentFragment(), colocados = [];
        novos.forEach(function (n) {
          n.removeAttribute('reveal');
          var c = document.importNode(n, true);
          if (avisar) c.classList.add('vvm-novo');
          pedaco.appendChild(c);
          colocados.push(c);
        });
        alvo.appendChild(pedaco);
        self.dataset.pagina = outro.dataset.pagina;
        self.innerHTML = outro.innerHTML;
        self.classList.remove('vvm--carregando');
        self.ocupado = false;
        self.ligar();
        rastrear(itens, avisar);
        return colocados;
      }).catch(function (erro) {
        self.ocupado = false;
        self.classList.remove('vvm--carregando');
        throw erro;
      });
    }

    recuperar() {
      var self = this, s = ler();
      if (tipoNavegacao() !== 'back_forward' || !s || !(s.ate > inicial)) { apagar(); return; }
      apagar();
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      (function proximo() {
        if ((Number(self.dataset.pagina) || 1) >= s.ate || !self.botao) {
          requestAnimationFrame(function () {
            window.scrollTo(0, s.y);
            if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
          });
          return;
        }
        self.carregar(false).then(proximo).catch(function () {
          if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        });
      })();
    }
  }

  customElements.define('viego-ver-mais', ViegoVerMais);
})();
